import { getItemByField } from "../../web-graphics";

export function getChannelUnitField(channelSettings, commonDataSettings, fieldName) {
  if (channelSettings.unit?.[fieldName] !== undefined) {
    return channelSettings.unit[fieldName];
  }
  let unitId = channelSettings.unit?.id_unit;
  if (unitId !== undefined) {
    const unitSettings = getItemByField("id", unitId, commonDataSettings.units);
    return unitSettings[fieldName];
  }
  const dataSourceSettings = getItemByField("id", channelSettings.id_dataSource, commonDataSettings.sources);
  channelSettings = getItemByField("id", channelSettings.id, dataSourceSettings.channels);
  if (channelSettings.unit === undefined) {
    return undefined;
  }
  if (channelSettings.unit[fieldName] !== undefined) {
    return channelSettings.unit[fieldName];
  }
  unitId = channelSettings.unit.id_unit;
  const commonUnitSettings = getItemByField("id", unitId, commonDataSettings.units);
  return commonUnitSettings[fieldName];
}

export function getChannelUnitText(channelSettings, commonDataSettings) {
  return getChannelUnitField(channelSettings, commonDataSettings, "text");
}

export function getChannelUnitScale(channelSettings, commonDataSettings) {
  return getChannelUnitField(channelSettings, commonDataSettings, "scale");
}
